/*let userProfile = null;*/

/*$(function () {
    userProfile = localStorage.getItem('user');
    userProfile = userProfile ? JSON.parse(userProfile) : {};
    if (userProfile) profileUpdate();
});*/

let userName = $("#userName");
let userPhone = $("#userPhone");
let userEmail = $("#userEmail");
let userChildName = $("#userChildName");
let userGradeName = $("#userGradeName");
let userChildGender = $("#userChildGender");

window.profileUpdate = () => {
    let userProfileData;
    mainApiAxios.get(`/get-profile-data`).then(res => {

        userProfileData = res.data;
        let fetchedData = userProfileData.data;

        $('.pcc-spinner').removeClass('d-flex').addClass('d-none');
        $('.pcc-form').removeClass('d-none');


        let userNameVal = fetchedData.name;
        if (userNameVal) {
            userName.val(userNameVal);
            userName.prop('disabled', true);
        }


        let userPhoneVal = fetchedData.phone;
        if (userPhoneVal) {
            userPhone.val(userPhoneVal);
            userPhone.prop('disabled', true);
        }


        let userEmailVal = fetchedData.email;
        if (userEmailVal) {
            userEmail.val(userEmailVal);
            userEmail.prop('disabled', true);
        }


        let userChildNameVal = fetchedData.child_1_name;
        if (userChildNameVal) {
            userChildName.val(userChildNameVal);
            userChildName.prop('disabled', true);
        }


        let userGradeNameVal = fetchedData.child_1_grade;
        if (userGradeNameVal) {
            userGradeName.val(userGradeNameVal);
            userGradeName.prop('disabled', true);
        }


        let userChildGenderVal = fetchedData.child_1_gender;
        if (userChildGenderVal) {
            userChildGender.val(userChildGenderVal);
            userChildGender.prop('disabled', true);
        }


        $('#profilesSubBtn').prop('disabled', false);
        if (userNameVal.length > 0 && userPhoneVal.length > 0 && userEmailVal.length > 0 && userChildNameVal.length > 0 && userGradeNameVal.length > 0 && userChildGenderVal.length > 0) {
            $('#profilesSubBtn').prop('disabled', true);
        }
    }).catch(err => {
        console.log(err);
        $('.pcc-spinner').append(`<h2 class="fw-semibold text-center mb-5">Please Log in</h2>`)
    });
}


window.updateUserData = () => {
    let pushData = new FormData($(".pcc-form")[0]);

    pushData.append("name", userName.val());
    pushData.append("phone", userPhone.val());
    pushData.append("email", userEmail.val());
    pushData.append("child_1_name", userChildName.val());
    pushData.append("child_1_grade", userGradeName.val());
    pushData.append("child_1_gender", userChildGender.val());

    mainApiAxios.post(`/submit-profile`, pushData).then(function (res) {
        let response = res.data;
        console.log(response);
        location.reload();
    });
}

$('#profilesSubBtn').on('click', async function (e) {
    updateUserData();
    $('#profilesSubBtn').prop('disabled', true);
});
